<template>
  <!-- Quotation定制化服务-报价(列表) -->
  <div class="packageWrap" v-if="quotationList?.length > 0">
    <div class="mb20 shadeWrap" v-for="(parent, index) in quotationList" :key="`parent${index}`">
      <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
        <el-col :span="7">
          <p class="fs14 fwb billingTo">
            Billing to
            <span v-if="currentLanguage == 'zh'">属于</span>
            :
            <span class="fw400 fs14">{{ parent.companyTitle }}</span>
          </p>
        </el-col>
        <el-col :span="8">
          <p class="fs14 fwb billingTo">
            Address
            <span v-if="currentLanguage == 'zh'">地址</span>
            :
            <span class="fw400 fs14">{{ parent.companyAddress }}</span>
          </p>
        </el-col>
        <el-col :span="5">
          <p class="fs14 fwb billingTo">
            Country
            <span v-if="currentLanguage == 'zh'">国家</span>
            :
            <span class="fw400 fs14">
              {{ getGlobalLabel("countryList", parent.companyCountry, currentLanguage) }}
            </span>
          </p>
        </el-col>
        <el-col :span="4">
          <p class="fs14 fwb billingTo">
            Code
            <span v-if="currentLanguage == 'zh'">邮编</span>
            :
            <span class="fw400 fs14">{{ parent.companyPostalCode }}</span>
          </p>
        </el-col>
      </el-row>
      <div class="billingTitle">
        <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
          <el-col :span="8">
            <p class="fs14 fwb tac">Fee Schedule</p>
            <p class="fs14 fwb tac" v-if="currentLanguage == 'zh'">收费安排</p>
          </el-col>
          <el-col :span="4">
            <p class="fs14 fwb tac">Covered Period</p>
            <p class="fs14 fwb tac" v-if="currentLanguage == 'zh'">涵盖的服务期间</p>
          </el-col>
          <el-col :span="3">
            <p class="fs14 fwb tac">Amount</p>
            <p class="fs14 fwb tac" v-if="currentLanguage == 'zh'">金额</p>
          </el-col>
          <el-col :span="3">
            <p class="fs14 fwb tac">Incl. Third Party Fee</p>
            <p class="fs14 fwb tac" v-if="currentLanguage == 'zh'">其中: 含第三方金额</p>
          </el-col>
          <el-col :span="3">
            <p class="fs14 fwb tac">Incl. Other Fee</p>
            <p class="fs14 fwb tac" v-if="currentLanguage == 'zh'">其中: 含其他金额</p>
          </el-col>
          <el-col :span="3">
            <p class="fs14 fwb tac">Payment Due Date</p>
            <p class="fs14 fwb tac" v-if="currentLanguage == 'zh'">支付到期日</p>
          </el-col>
        </el-row>
      </div>

      <div v-for="(sub, idx) in parent.partList" :key="`sub${idx}`">
        <!-- 内容 -->
        <div class="billingContent" v-for="(grand, ids) in sub.itemList" :key="`grand${ids}`">
          <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
            <el-col :span="8">
              <p class="fs14 tac lh16">
                {{ grand.title }}
              </p>
            </el-col>
            <el-col :span="4">
              <p class="fs14 tac lh16">{{ grand.startDate }} ~ {{ grand.endDate }}</p>
            </el-col>
            <el-col :span="3">
              <p class="fs14 tac lh16 orange newline">
                {{ priceCurrencyFormat(grand.amount, parent?.bankAccountList?.[0]?.billingCurrency) }}
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs14 tac lh16 orange newline">
                {{ priceCurrencyFormat(grand.thirdPartyFee, parent?.bankAccountList?.[0]?.billingCurrency) }}
                <el-popover placement="bottom" trigger="hover" v-if="grand.noteForThirdParty">
                  <p class="fs14">{{ grand.noteForThirdParty }}</p>
                  <span slot="reference" class="fs13 blackD8 el-icon-question"></span>
                </el-popover>
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs14 tac lh16 orange newline">
                {{ priceCurrencyFormat(grand.otherFee, parent?.bankAccountList?.[0]?.billingCurrency) }}
                <el-popover placement="bottom" trigger="hover" v-if="grand.noteForOther">
                  <p class="fs14">{{ grand.noteForOther }}</p>
                  <span slot="reference" class="fs13 blackD8 el-icon-question"></span>
                </el-popover>
              </p>
            </el-col>
            <el-col :span="3"></el-col>
          </el-row>
        </div>
        <!-- 小结 -->
        <div class="billingBrief">
          <el-row :gutter="10" class="pt10 pb10 fxRow borderTop borderBottom">
            <el-col :span="8">
              <p class="fs14 tac lh16">{{ sub.subTotalDesp }}</p>
            </el-col>
            <el-col :span="4"></el-col>
            <el-col :span="3">
              <p class="fs14 tac lh16 pb2">
                Subtotal
                <span v-if="currentLanguage == 'zh'">小计总额</span>
              </p>
              <p class="fs14 tac lh16 orange newline">
                {{ priceCurrencyFormat(sub.subTotalPrice, parent?.bankAccountList?.[0]?.billingCurrency) }}
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs14 tac lh16 pb2">
                Subtotal
                <span v-if="currentLanguage == 'zh'">小计数</span>
              </p>
              <p class="fs14 tac lh16 orange newline">
                {{ priceCurrencyFormat(sub.subTotalThirdPartyFee, parent?.bankAccountList?.[0]?.billingCurrency) }}
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs14 tac lh16 pb2">
                Subtotal
                <span v-if="currentLanguage == 'zh'">小计数</span>
              </p>
              <p class="fs14 tac lh16 orange newline">
                {{ priceCurrencyFormat(sub.subTotalOtherFee, parent?.bankAccountList?.[0]?.billingCurrency) }}
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs14 tac lh16" v-if="sub.isDownPayment == 1">
                Payable upon submission
                <span v-if="currentLanguage == 'zh'">订单提交时即时支付</span>
              </p>
              <p class="fs14 tac lh16" v-if="sub.isDownPayment == 0">
                {{ sub.paymentDueTime }}
              </p>
            </el-col>
          </el-row>
          <!-- 空格 -->
          <div class="wdb100 hg40"></div>
        </div>
      </div>

      <!-- 总结 -->
      <div class="billingBottom">
        <el-row :gutter="10" class="pt10 pb10 fxRow borderTop borderBottom">
          <el-col :span="8">
            <p class="fs14 tac lh16">{{ parent.sumTotalDesp }}</p>
          </el-col>
          <el-col :span="4"></el-col>
          <el-col :span="3">
            <p class="fs14 tac lh16 pb2">
              Total
              <span v-if="currentLanguage == 'zh'">合计总额</span>
            </p>
            <p class="fs14 tac lh16 orange newline">
              {{ priceCurrencyFormat(parent.sumTotalPrice, parent?.bankAccountList?.[0]?.billingCurrency) }}
            </p>
          </el-col>
          <el-col :span="3">
            <p class="fs14 tac lh16 pb2">
              Total
              <span v-if="currentLanguage == 'zh'">合计数</span>
            </p>
            <p class="fs14 tac lh16 orange newline">
              {{ priceCurrencyFormat(parent.sumTotalThirdPartyFee, parent?.bankAccountList?.[0]?.billingCurrency) }}
            </p>
          </el-col>
          <el-col :span="3">
            <p class="fs14 tac lh16 pb2">
              Total
              <span v-if="currentLanguage == 'zh'">合计数</span>
            </p>
            <p class="fs14 tac lh16 orange newline">
              {{ priceCurrencyFormat(parent.sumTotalOtherFee, parent?.bankAccountList?.[0]?.billingCurrency) }}
            </p>
          </el-col>
          <el-col :span="3"></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import formatMixin from "@/mixins/formatMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin],
  props: {
    quotationList: {
      type: Array,
      default: () => [],
    },
    // 语言来源：父组件可显式指定（如临时语言）；不传则回退全局语言
    lang: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["getGlobalLabel"]),
    // 组件内实际使用的语言
    currentLanguage() {
      return this.lang || this.getLanguage;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  width: 100%;

  .shadeWrap {
    width: 100%;
    background-color: #fdf6ec;
    padding: 0px 5px;
    margin-top: 6px;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
  }

  .borderTop {
    border-top: 1px solid #e4e7ed;
  }

  .borderBottom {
    border-bottom: 1px solid #e4e7ed;
  }
}
</style>
